import { Checkbox } from "@mui/material";
import { useEffect, useState } from "react";
import { Button } from "src/components/ui/button";
import { useUserStore } from "src/zustand/userStore";
import { Product } from "../cart/cart-preview";

interface Props {
  onClick: () => void;
}
export const PaymentPreview = ({ onClick }: Props) => {
  const [selected, setSelected] = useState(false);
  const [error, setError] = useState("");

  const store = useUserStore();

  const amount = `${store.paymentInfo?.products
    .reduce((acc, product) => acc + parseFloat(product.price.replace(",", ".")), 0)
    .toFixed(2)
    .replace(".", ",")}`;

  const uniqueProductsMap = new Map<string, Product>();

  store.paymentInfo?.products.forEach((product: Product) => {
    if (uniqueProductsMap.has(product.name)) {
      const existingProduct = uniqueProductsMap.get(product.name)!;
      existingProduct.quantity = (existingProduct.quantity || 0) + 1;
      existingProduct.price = (
        parseFloat(existingProduct.price.replace(",", ".")) + parseFloat(product.price.replace(",", "."))
      )
        .toFixed(2)
        .replace(".", ",") + " €";
    } else {
      uniqueProductsMap.set(product.name, { ...product, quantity: 1 });
    }
  });

  const uniqueProducts = Array.from(uniqueProductsMap.values());

  useEffect(() => {
    console.log({ uniqueProducts });
  }, [uniqueProducts]);

  return (
    <div className="rounded-xl overflow-hidden bg-white flex-grow">
      <div className="flex flex-col justify-center h-fit p-4 gap-3 text-black text-xl font-medium border-b-2 border-[#f3f3f8]">
        <div className="flex flex-col">
          {/* Assuming store.paymentInfo?.products is your array of products */}
          {uniqueProducts.map((product, index) => (
            <div className="flex justify-between" key={index}>
              <span className="text-base">
                {product.name} ({product.quantity})
              </span>
            </div>
          ))}
        </div>
      </div>
      <div className="flex flex-col p-4">
        <div className="pb-5 flex items-center justify-between font-bold">
          <p className="text-xl">Total commande</p>
          <h3 className="text-2xl">{amount} €</h3>
        </div>
        <div className="mb-5">
          <div className="w-full flex items-center gap-3">
            <Checkbox
              checked={selected}
              onChange={() => {
                setError("");
                setSelected(!selected);
              }}
              id="confirm-checkbox"
              className="max-w-6"
            />
            <label htmlFor="confirm-checkbox" className="text-sm text-[#5e6878]">
              J'ai pris connaissance des conditions ci-après et je les accepte
            </label>
          </div>
          {error && (
            <span className="flex items-center pl-3 pt-3">
              <svg
                aria-hidden="true"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
                className="fill-destructive mr-2 min-w-4 size-4"
              >
                <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM16.7548 15.3986C16.7799 15.4592 16.7928 15.5242 16.7928 15.5899C16.7928 15.6556 16.7799 15.7206 16.7548 15.7813C16.7296 15.8419 16.6928 15.897 16.6464 15.9435L15.9435 16.6463C15.897 16.6928 15.8419 16.7296 15.7813 16.7547C15.7206 16.7799 15.6556 16.7928 15.5899 16.7928C15.5243 16.7928 15.4592 16.7799 15.3986 16.7547C15.3379 16.7296 15.2828 16.6928 15.2364 16.6463L12.3535 13.7635C12.3071 13.717 12.2519 13.6802 12.1913 13.6551C12.1306 13.63 12.0656 13.617 11.9999 13.617C11.9343 13.617 11.8693 13.63 11.8086 13.6551C11.7479 13.6802 11.6928 13.717 11.6464 13.7635L8.76348 16.6463C8.71706 16.6928 8.66193 16.7296 8.60127 16.7547C8.54061 16.7799 8.47559 16.7928 8.40993 16.7928C8.34427 16.7928 8.27925 16.7799 8.21859 16.7547C8.15792 16.7296 8.1028 16.6928 8.05638 16.6463L7.35348 15.9435C7.30705 15.897 7.27022 15.8419 7.24509 15.7813C7.21996 15.7206 7.20703 15.6556 7.20703 15.5899C7.20703 15.5242 7.21996 15.4592 7.24509 15.3986C7.27022 15.3379 7.30705 15.2828 7.35348 15.2363L10.2364 12.3535C10.2828 12.307 10.3196 12.2519 10.3448 12.1913C10.3699 12.1306 10.3828 12.0656 10.3828 11.9999C10.3828 11.9343 10.3699 11.8692 10.3448 11.8086C10.3196 11.7479 10.2828 11.6928 10.2364 11.6463L7.35348 8.76348C7.30705 8.71705 7.27022 8.66193 7.24509 8.60126C7.21996 8.5406 7.20703 8.47558 7.20703 8.40992C7.20703 8.34426 7.21996 8.27924 7.24509 8.21857C7.27022 8.15791 7.30705 8.10279 7.35348 8.05636L8.05638 7.35348C8.1028 7.30705 8.15792 7.27022 8.21859 7.24509C8.27925 7.21996 8.34427 7.20703 8.40993 7.20703C8.47559 7.20703 8.54061 7.21996 8.60127 7.24509C8.66193 7.27022 8.71706 7.30705 8.76348 7.35348L11.6464 10.2363C11.6928 10.2828 11.7479 10.3196 11.8086 10.3447C11.8693 10.3699 11.9343 10.3828 11.9999 10.3828C12.0656 10.3828 12.1306 10.3699 12.1913 10.3447C12.2519 10.3196 12.3071 10.2828 12.3535 10.2363L15.2364 7.35348C15.2828 7.30705 15.3379 7.27022 15.3986 7.24509C15.4592 7.21996 15.5243 7.20703 15.5899 7.20703C15.6556 7.20703 15.7206 7.21996 15.7813 7.24509C15.8419 7.27022 15.897 7.30705 15.9435 7.35348L16.6464 8.05636C16.6928 8.10279 16.7296 8.15791 16.7548 8.21857C16.7799 8.27924 16.7928 8.34426 16.7928 8.40992C16.7928 8.47558 16.7799 8.5406 16.7548 8.60126C16.7296 8.66193 16.6928 8.71705 16.6464 8.76348L13.7635 11.6463C13.7171 11.6928 13.6802 11.7479 13.6551 11.8086C13.63 11.8692 13.617 11.9343 13.617 11.9999C13.617 12.0656 13.63 12.1306 13.6551 12.1913C13.6802 12.2519 13.7171 12.307 13.7635 12.3535L16.6464 15.2363C16.6928 15.2828 16.7296 15.3379 16.7548 15.3986Z"></path>
              </svg>
              <p className="text-[0.8rem] font-medium text-destructive">
                {error}
              </p>
            </span>
          )}
        </div>
        <ul className="flex flex-col gap-3 mb-5 ml-8 text-[0.8125rem] text-[#127996]">
          {[
            "Conditions Générales de Vente SNCF",
            "Conditions Générales de Vente et d’Utilisation du site SNCF Connect",
            "Charte de confidentialité de SNCF Connect",
          ].map((item) => (
            <li className="cursor-pointer">
              {item}
              <svg
                aria-hidden="true"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
                className="size-4 fill-[#127996] inline-block ml-1"
              >
                <path d="M19.7789 12.5524V18.6564C19.778 19.2739 19.5322 19.8658 19.0955 20.3024C18.6587 20.7389 18.0667 20.9844 17.4492 20.985H5.3297C4.71219 20.9844 4.12012 20.7389 3.68338 20.3024C3.24663 19.8658 3.00087 19.2739 3 18.6564V6.44946C3.00064 5.83178 3.24629 5.23958 3.68306 4.80282C4.11982 4.36605 4.71202 4.1204 5.3297 4.11976H11.2589C11.3472 4.11942 11.4347 4.13652 11.5164 4.17009C11.5981 4.20365 11.6724 4.25302 11.735 4.31535C11.7975 4.37769 11.8472 4.45177 11.8811 4.53334C11.915 4.61491 11.9324 4.70237 11.9324 4.79069C11.9324 4.87902 11.915 4.96648 11.8811 5.04805C11.8472 5.12962 11.7975 5.2037 11.735 5.26604C11.6724 5.32837 11.5981 5.37774 11.5164 5.4113C11.4347 5.44487 11.3472 5.46197 11.2589 5.46163H5.3297C5.06797 5.46214 4.81712 5.56642 4.63215 5.75159C4.44719 5.93677 4.34319 6.18773 4.34297 6.44946V18.6564C4.34323 18.918 4.44728 19.1688 4.63227 19.3538C4.81726 19.5388 5.06808 19.6428 5.3297 19.6431H17.4492C17.7108 19.6428 17.9616 19.5388 18.1466 19.3538C18.3316 19.1688 18.4356 18.918 18.4359 18.6564V12.5524C18.4359 12.3743 18.5067 12.2035 18.6326 12.0775C18.7585 11.9516 18.9293 11.8808 19.1074 11.8808C19.2855 11.8808 19.4563 11.9516 19.5822 12.0775C19.7082 12.2035 19.7789 12.3743 19.7789 12.5524L19.7789 12.5524ZM20.9482 3.42936C20.8971 3.30702 20.811 3.20247 20.7008 3.12878C20.5906 3.05508 20.4611 3.01551 20.3285 3.01502H15.3287C15.2404 3.01468 15.1529 3.03178 15.0712 3.06535C14.9895 3.09891 14.9152 3.14828 14.8526 3.21061C14.7901 3.27295 14.7404 3.34703 14.7065 3.4286C14.6726 3.51017 14.6552 3.59763 14.6552 3.68595C14.6552 3.77428 14.6726 3.86174 14.7065 3.94331C14.7404 4.02488 14.7901 4.09896 14.8526 4.1613C14.9152 4.22363 14.9895 4.273 15.0712 4.30656C15.1529 4.34013 15.2404 4.35723 15.3287 4.35689H18.7085L11.5544 11.511C11.429 11.637 11.3587 11.8076 11.3589 11.9854C11.3591 12.1632 11.4299 12.3336 11.5557 12.4593C11.6815 12.5849 11.852 12.6555 12.0298 12.6556C12.2076 12.6556 12.3782 12.5851 12.504 12.4595L19.657 5.30648V8.68628C19.657 8.86437 19.7278 9.03517 19.8537 9.1611C19.9796 9.28703 20.1504 9.35778 20.3285 9.35778C20.5066 9.35778 20.6774 9.28703 20.8033 9.1611C20.9293 9.03517 21 8.86437 21 8.68628V3.68598C20.9998 3.59786 20.9821 3.51066 20.9482 3.42935V3.42936Z"></path>
              </svg>
            </li>
          ))}
        </ul>
        <Button
          className="mx-auto min-w-[80%]"
          onClick={() => {
            setError("");
            if (!selected) {
              setError("Vous devez d’abord accepter les conditions.");
              return;
            }
            onClick();
          }}
        >
          Payer {amount} €
        </Button>
      </div>
    </div>
  );
};
